import {AsyncInlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

import {LocalStorageAssistantRepository} from '../Repositories/LocalStorageAssistantRepository.js'

class LoadAssistantChatUseCase extends UseCase {
  #repository

  constructor({repository}) {
    super()
    this.#repository = repository
  }

  static create({config}) {
    return new LoadAssistantChatUseCase({
      repository: LocalStorageAssistantRepository.create({config})
    })
  }

  @tracer({metric: 'LoadAssistantChatUseCase#execute'})
  @AsyncInlineError()
  async execute({chatId} = {}) {
    return this.#repository.loadChat(chatId)
  }
}

export const factory = LoadAssistantChatUseCase.create
